// extracted by mini-css-extract-plugin
export var borderRadius = "_fg-4";
export var large = "_fg-3";
export var logoContainer = "_fg-0";
export var nameLogo = "_fg-2";
export var small = "_fg-1";